import storage from "@/storage";
import { IAccessStorage, IAuthStorage, IClientStorage, ILoginStorage, ISiteStorage, IUserStorage } from "@/storage/model";
import { BaseAuthBloc } from "./bloc.base";

export class BoxAuthBloc extends BaseAuthBloc {
    async saveStorage(data: any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const auth: IAuthStorage = data.auth;
            await storage.set<IAuthStorage>(storage.AUTH, auth);

            const client: IClientStorage = data.configuration.selected_client;
            await storage.set<IClientStorage>(storage.CLIENT, client);

            const site: ISiteStorage = data.configuration.selected_site;
            await storage.set<ISiteStorage>(storage.SITE, site);

            const permission: string[] = data.configuration.user_permission;
            await storage.set<string[]>(storage.PERMISSION, permission);

            const user: IUserStorage = data.user;
            await storage.set<IUserStorage>(storage.USER, user);

            const loginToken: ILoginStorage = data.login_token;
            await storage.set<ILoginStorage>(storage.LOGIN_TOKEN, loginToken);

            const alarm = true;
            await storage.set<any>(storage.ALARM, alarm);
            resolve(true);
        });
    }
}